import { createTheme } from "@mui/material/styles";

export const theme = createTheme({
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          "&:hover, &.Mui-focused": {
            backgroundColor: "#EAF9FF !important",
          },
        },
        noOptions: {
          textAlign: "left",
          font: "normal normal bold 14px/18px Quicksand",
          letterSpacing: "0px",
          color: "#161A1D",
          opacity: "1"
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#F5325B",
          marginTop: "-3px",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "& input": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
  palette: {
    mode: "light",
    primary: { // inno blue
      main: "#16124c",
    },
    secondary: { // inno pink
      main: "#ac5ccc",
      blue: "#209BDE",
      green: "#4AA3A5",
    },
    tertiary: { // inno green
      main: "#69B01C"
    },
    white: {
      main: "#fff",
      secondary: "#F6F8FA",
    },
    grey: {
      main: "#707070",
      secondary: "#8C99A6",
      third: "#E2E6E9",
      fourth: "#F3F4F5",
      fifth: "#F6F8FA",
    },
    black: {
      primary: "#161A1D",
    },
    info: {
      main: "#13a6a6",
    },
    error: {
      main: "#F5325B",
    },
    text: {
      primary: "#6F8090",
      secondary: "#f5f5f5",
    },
    background: {
      default: "#F6F8FA",
    },
    warning: {
      main: "#ffca00",
    },
    success: {
      main: "#7ED321",
    },
    highlight: {
      main: "#CCEDFF",
    },
    link: {
      main: "#00A6FF"
    }
  },
  typography: {
    fontFamily: "Quicksand",
    h1: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    h2: {
      fontSize: "18px",
      fontWeight: "bold",
    },
    h3: {
      fontSize: "16px",
      fontWeight: "bold",
    },
    h4: {
      fontSize: "22px",
      fontWeight: "bold",
    },
    h5: {
      fontSize: ".8rem",
      fontWeight: "bold",
    },
    h6: {
      fontSize: ".7rem",
      fontWeight: "bold",
    },
    subtitle1: {
      fontFamily: "Quicksand",
    },
    subtitle2: {
      fontFamily: "Quicksand",
    },
    body1: {
      fontFamily: "Lato",
      fontSize: "14px",
    },
    body2: {
      fontFamily: "Lato",
      fontSize: "12px"
    },
    body3: {
      fontFamily: "Lato",
      fontSize: "10px"
    },
    formLabel1: {
      fontFamily: "Lato",
      fontSize: "13px",
      fontWeight: 'bold',
      color: '#6F8090',
    },
    buttonText1: {
      fontFamily: "Lato",
      fontSize: "14px",
      fontWeight: 700,
      color: '#16124C',
      textTransform: 'none',
    },
    buttonTextSmall: {
      fontFamily: "Lato",
      fontSize: "10px",
      fontWeight: 700,
    },
  },
  props: {
    MuiAppBar: {
      color: "secondary",
    },
  },
  main: {
    sidebarWidth: 80,
    headerMinWidth: 725,
    headerHeight: 55,
  },
  page: {
    pageItems: {
      borderRadius: "10px",
      padding: "10px",
    },
    itemSpacing: "10px",
    pageMenuButton: {
      height: "100%",
      width: "60px",
      maxWidth: "60px",
      minWidth: "60px",
    },
    pageMenu: {
      width: "280px",
    },
  },
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    boxShadow: 24,
    background: "#FFFFFF 0% 0% no-repeat padding-box",
  },
  dropdownButton: {
    font: {
      color: "var(--Neutrals-900, #6F8090)",
      fontFamily: "Lato",
      fontSize: "14px !important",
      fontStyle: "normal",
      fontWeight: "700",
      lineHeight: "normal"
    }
  },
  dashNameModal: {
    width: "520px",
    height: "350px",
  },
  transDashOwnModal: {
    width: "350px",
    height: "242px",
  },
  unpublishDashModal: {
    width: "519px",
    height: "292px",
  },
  publishDashModal: {
    width: "954px",
    height: "538px",
  },
  chartTypeConfirmModal: {
    height: "191.72px",
    width: "519px",
  },
  modalHeader: {
    textAlign: "left",
    fontFamily: "Lato",
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "23px",
    letterSpacing: "0px",
    color: "#1B247E",
    textTransform: "uppercase",
    opacity: 1,
  },
  modalTextfield: {
    "& .MuiAutocomplete-root": { height: "30px" },
    "& .MuiPaper-root": {
      maxHeight: "30px",
    },
    "& .MuiInputBase-root": {
      height: "30px",
      padding: "0px",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      height: "33px",
    },
    "& .MuiInputBase-input": {
      height: "18px",
      paddingTop: "5px !important",
      paddingBottom: "7px !important",
      paddingLeft: "12px !important",
      textAlign: "left",
      font: "normal normal bold 14px/18px Quicksand",
      letterSpacing: "0px",
      color: "#23247b",
      opacity: "1",
    },
  },

  modalInputHeader: {
    textAlign: "left",
    fontFamily: "Lato",
    fontWeight: "bold",
    fontSize: "16px",
    lineHeight: "20px",
    letterSpacing: "0px",
    color: "#899AA7",
    marginBottom: "19px",
    opacity: 1,
  },

  modalButton: {
    box: {
      width: "127px",
      height: "30px",
      marginTop: "15px",
      marginLeft: "13px",
      marginRight: "13px",
      border: "2px solid #23247B",
      borderRadius: "6px",
      opacity: "1",
    },
    text: {
      textAlign: "center",
      fontFamily: "Lato",
      fontWeight: 900,
      fontSize: "13px",
      lineHeight: "16px",
      letterSpacing: "0px",
      color: "#1B247E",
      textTransform: "uppercase",
      opacity: "1",
    },
  },

  editModal: {
    width: {
      xs: "660px", // For screens smaller than 'md'
      md: "954px", // For screens 'md' (900px wide) and larger
    },
    height: {
      xs: "430px", // For screens smaller than 'md'
      md: "538px", // For screens 'md' (900px wide) and larger
    },
    borderRadius: "10px",
  },
  accountModal: {
    width: "519px",
    height: "542px",
    borderRadius: "10px",
  },
  fitSpace: {
    width: "100%",
    height: "100%",
  },
  chartCard: {
    height: "220px",
    width: "330px",
  },
  table: {
    tableHeadCell: {
      backgroundColor: "#EBF8FF",
      fontFamily: "Lato",
      fontSize: "14px",
      fontWeight: "bold",
      color: "#707070",
      opacity: 1,
      paddingBottom: "10px",
      paddingTop: "10px",
      borderBottom: "10px solid #F6F8FA",
    },
    tableBodyCell: {
      fontFamily: "Lato",
      fontSize: "12px",
      fontWeight: "bold",
      color: "#707070",
      opacity: 1,
      paddingBottom: "0px",
      paddingTop: "0px",
      borderBottom: "5px solid #F6F8FA",
    },
  },
  dropdownListStyles:{
    textAlign: "left",
    font: "normal normal bold 14px/18px Lato",
    letterSpacing: "0px",
    color: "#161A1D",
    opacity: "1"
  }
});
